import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';

const ENDPOINT_URL = '/auth/refresh';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type RefreshTokenSuccessResponse = paths[url]['post']['responses']['200']['content']['application/json'];

export const useRefreshToken = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { login, setLogin } = useData();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const err = new Error(json.message || '') as ApiError;
                err.statusCode = response.status;
                throw err;
            }

            const data: RefreshTokenSuccessResponse = await response.json();
            if (login) {
                setLogin({ ...login, ...data });
            }
        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return { request, loading, error };
};
